import { render, staticRenderFns } from "./PortfolioResearchStatement.vue?vue&type=template&id=2f6c8268&scoped=true&"
import script from "./PortfolioResearchStatement.vue?vue&type=script&lang=js&"
export * from "./PortfolioResearchStatement.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioResearchStatement.vue?vue&type=style&index=0&id=2f6c8268&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c8268",
  null
  
)

export default component.exports